import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { IonChip, IonInfiniteScroll, IonInfiniteScrollContent, InfiniteScrollCustomEvent } from '@ionic/angular';
import { Store } from '@ngrx/store';

import {
  NtyToolbarComponent,
  NtyTopToolbarContentComponent,
  NtyToolbarBottomContentComponent,
  PageComponent,
} from '@ninety/mobile/platform/components';
import { LanguageSelectors } from '@ninety/mobile/platform/state';
import { TerraIconModule } from '@ninety/terra';

import { NotificationFeedActions } from '../../_state/notification-feed-state.actions';
import { NotificationFeedSelectors } from '../../_state/notification-feed-state.selectors';
import { NinetyNotification } from '../../models/ninety-notification.model';
import { NotificationFilterOptions } from '../../models/notification-filter-options';
import { NotificationCardComponent } from '../notification-card/notification-card.component';

@Component({
  selector: 'nty-notification-feed',
  imports: [
    CommonModule,
    TerraIconModule,
    NtyToolbarComponent,
    NtyTopToolbarContentComponent,
    NtyToolbarBottomContentComponent,
    NotificationCardComponent,
    IonChip,
    PageComponent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
  ],
  templateUrl: './notification-feed.component.html',
  styleUrls: ['./notification-feed.component.scss'],
})
export class NotificationFeedComponent implements OnInit {
  private readonly store = inject(Store);

  readonly vm$ = this.store.select(NotificationFeedSelectors.selectFeedVm);
  readonly language$ = this.store.select(LanguageSelectors.language);

  readonly filterOptions = [
    { label: 'All', value: NotificationFilterOptions.all },
    { label: 'Unread', value: NotificationFilterOptions.unread },
    { label: 'Mentions', value: NotificationFilterOptions.mention },
    { label: 'Assigned to me', value: NotificationFilterOptions.assignment },
    { label: 'Comments', value: NotificationFilterOptions.comment },
    { label: 'Read', value: NotificationFilterOptions.read },
  ];

  ngOnInit(): void {
    this.store.dispatch(NotificationFeedActions.open());
  }

  onNotificationClick(notification: NinetyNotification): void {
    this.store.dispatch(NotificationFeedActions.openItemDetail({ notification }));
  }

  onToggleReadStatus(notification: NinetyNotification): void {
    this.store.dispatch(NotificationFeedActions.toggleNotificationReadStatus({ notification }));
  }

  onMarkAllAsRead(): void {
    this.store.dispatch(NotificationFeedActions.markAllAsRead());
  }

  onFilterChange(filterBy: NotificationFilterOptions): void {
    this.store.dispatch(NotificationFeedActions.setFilterOption({ filterBy }));
  }

  handleRefresh(): void {
    // PageComponent stops the spinner, so the action no longer carries the refresher event.
    this.store.dispatch(NotificationFeedActions.refreshFeed({}));
  }

  onIonInfinite(event: InfiniteScrollCustomEvent): void {
    this.store.dispatch(NotificationFeedActions.loadMoreNotifications({ event }));
  }
}
